import { useEffect, useRef, useState } from "react";

export const usePollingInterval = (callback, delay, isMounted = true) => {
    const [hasMadeInitialCall, setHasMadeInitialCall] = useState(false);
    const savedCallback = useRef();
    const mounted = useRef(isMounted);

    // Update the mounted ref when the component is mounted/unmounted
    useEffect(() => {
        mounted.current = isMounted;
    }, [isMounted]);

    // Perform the initial call if not made yet and the component is mounted
    useEffect(() => {
        if (mounted.current && !hasMadeInitialCall) {
            callback();
            setHasMadeInitialCall(true);
        }
    }, [callback, hasMadeInitialCall]);

    // Save the callback to the ref so it can be called within the interval
    useEffect(() => {
        if (mounted.current && hasMadeInitialCall) {
            savedCallback.current = callback;
        }
    }, [callback, hasMadeInitialCall]);

    // Set up the polling interval, but only if mounted
    useEffect(() => {
        if (mounted.current && hasMadeInitialCall) {
            function tick() {
                if (mounted.current) {
                    savedCallback.current();
                }
            }

            if (delay !== null) {
                const id = setInterval(tick, delay);
                return () => clearInterval(id);
            }
        }
    }, [delay, hasMadeInitialCall]);
};

const pollingService = { usePollingInterval };

export default pollingService;
